import config from "lib/config";
import { SELECT_TYPE } from "util/constant";
export const getProfileUrl = (
  profile_id,
  type,
  isDotRealtor = false,
  isDotRealtorWebURL = false,
) => {
  let profileUrl = "#";
  let baseUrl = "";
  if (typeof window !== "undefined") {
    baseUrl =
      window.location.protocol +
      "//" +
      window.location.hostname +
      (window.location.port ? ":" + window.location.port : "");
  }
  if (isDotRealtor) return baseUrl;
  switch (type) {
    case SELECT_TYPE.AGENT:
      if (isDotRealtorWebURL) {
        profileUrl = `https://www.realtor.com/${getDynamicRoute()}/${profile_id}`;
      } else {
        profileUrl = `${baseUrl}/${getDynamicRoute()}/${profile_id}`;
      }
      break;
    case SELECT_TYPE.TEAM:
      profileUrl = `${baseUrl}/realestateteam/${profile_id}`;
      break;
    case SELECT_TYPE.OFFICE:
      profileUrl = `${baseUrl}/realestateagency/${profile_id}`;
      break;
  }
  return profileUrl;
};

export const getDynamicRoute = () => {
  return config.DYNAMIC_URL_PATH;
};

export const getFindaRealtorRoute = () => {
  let baseUrl = "";
  if (typeof window !== "undefined") {
    baseUrl =
      window.location.protocol +
      "//" +
      window.location.hostname +
      (window.location.port ? ":" + window.location.port : "");
  }
  return `${baseUrl}/realtors?searchBy=Agent`;
};

export const getLandedRoutePath = () => {
  if (typeof window !== "undefined") {
    const baseUrl = window.location.pathname?.split("/");
    return baseUrl.length > 1 ? baseUrl[1] : config.DYNAMIC_URL_PATH;
  }
  return config.DYNAMIC_URL_PATH;
};
